import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronDownSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.1768 12.7627C12.0791 12.8603 11.9209 12.8603 11.8232 12.7627L8.53033 9.46982C8.23744 9.17693 7.76256 9.17693 7.46967 9.46982C7.17678 9.76271 7.17678 10.2376 7.46967 10.5305L10.7626 13.8234C11.446 14.5068 12.554 14.5068 13.2374 13.8234L16.5303 10.5305C16.8232 10.2376 16.8232 9.76271 16.5303 9.46982C16.2374 9.17693 15.7626 9.17693 15.4697 9.46982L12.1768 12.7627Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownSmall;
